import { css } from 'styled-components';

export const assetLinkStyle = css`
  color: ${({ theme }) => theme['border--interactive--toggled-default']};
  width: fit-content;
  cursor: pointer;
`;
